import Form from '../../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../../utils/analytics-helper';

export default class ConsentSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.consent-view');
        this.form = new Form(this.el.querySelector('.consent-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.interestInList = this.el.querySelector('[data-id="interested-in"]')?.querySelectorAll('input[type="checkbox"]');
        this.selectedInterestInList = '';
        this.contactByList = this.el.querySelector('[data-id="contact-by"]')?.querySelectorAll('input[type="checkbox"]');
        this.selectedContactByList = '';
        this.bind();
    }

    bind() {
        const self = this;
        this.interestInList?.forEach(elm => {
            elm.addEventListener('change',function() {
                self.selectedInterestInList = Array.from(self.interestInList)
                .reduce((acc,elm,ind,arr) => {
                    let label = elm.closest('.checkbox_label').innerText.trim().toLowerCase();
                    if(elm.checked){
                        acc.interestInListLabel.push(label);
                        acc.interestInList += `${label}-yes`;
                    }
                    if(!elm.checked){
                        acc.interestInList += `${label}-no`;
                    }
                    if((arr.length-1) !== ind) {  
                        acc.interestInList += ',';
                    }
                    return acc;
                },{interestInListLabel:[],interestInList:''});
                self.analyticsPush('interestIn');
            })
        });

        self.contactByList?.forEach(elm => {
            elm.addEventListener('change', function() {
                self.selectedContactByList = Array.from(self.contactByList)
                .reduce((acc,el,ind,arr) => {
                    let label = el.closest('.checkbox_label').innerText.trim().toLowerCase();
                    if(el.checked){
                        acc += `${label}-yes`;
                    }
                    if(!el.checked){
                        acc += `${label}-no`;
                    }
                    if((arr.length-1) !== ind) {  
                        acc += ',';
                    }
                    return acc;
                },'');
                self.analyticsPush('contactBy');
            })
        })
    }

    onSuccess(result) {
        this.form.showSuccess();
        window.HONDA.MyAccount2.onLogin();
        this.analyticsPush('submit');
    }

    onError(result) {
        this.form.showError();
        this.form.hideSuccess();
        this.analyticsPush('submit');
    }

    analyticsPush(result) {
        const {interestInListLabel,interestInList} = this.selectedInterestInList;
        if(result === 'interestIn') {
            AnalyticsHelper.push({
                event:'marketing_consent',
                eventCategory:'marketing consent',
                eventAction:'select interest',
                eventLabel:`${dataLayer[0].productCategory}|marketing consent|${interestInList}|internal|#`,
                actionType:'select interest',
                businessUnit: dataLayer[0].productCategory,
                moduleName:'marketing consent',
                clickText:`${interestInList}`,
                clickType:'internal', 
                destinationURL: '',
            });
        }
        if(result === 'contactBy') {
            AnalyticsHelper.push({
                event:'marketing_consent',
                eventCategory:'marketing consent',
                eventAction:'select communication',
                eventLabel:`${dataLayer[0].productCategory}|marketing consent|${this.selectedContactByList}|internal|#`,
                actionType:'select communication',
                businessUnit: dataLayer[0].productCategory,
                moduleName:'marketing consent',
                clickText:`${this.selectedContactByList}`,
                clickType:'internal', 
                destinationURL: '',
            });
        }
        if(result === 'submit') {
            AnalyticsHelper.push({
                event:'marketing_consent',
                eventCategory:'marketing consent',
                eventAction:'marketing consent submission',
                eventLabel:`${dataLayer[0].productCategory}|marketing consent|${interestInListLabel.join(',')}|internal|#`,
                actionType:'marketing consent submission',
                businessUnit: dataLayer[0].productCategory,
                moduleName:'marketing consent',
                clickText:`${interestInListLabel.join(',')}`,
                clickType:'internal', 
                destinationURL: '',
            });
        }
    }
}